<p-progressSpinner [style]="{ width: size, height: size }" />
